module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<a class="ui-theme-thumb-theme" href="' +
__e( href ) +
'">\n    <h2 class="title colored ' +
__e( color ) +
'">\n        ' +
__e( name ) +
'\n    </h2>\n    <div class="ui-theme-thumb-layers">\n        <img class="ui-theme-thumb-tile-1" src="https://a.tile.openstreetmap.fr/osmfr/' +
__e( z ) +
'/' +
__e( x1 ) +
'/' +
__e( y1 ) +
'.png" alt="" />\n        <img class="ui-theme-thumb-tile-2" src="https://a.tile.openstreetmap.fr/osmfr/' +
__e( z ) +
'/' +
__e( x2 ) +
'/' +
__e( y2 ) +
'.png" alt="" />\n        <img class="ui-theme-thumb-tile-3" src="https://a.tile.openstreetmap.fr/osmfr/' +
__e( z ) +
'/' +
__e( x3 ) +
'/' +
__e( y3 ) +
'.png" alt="" />\n    </div>\n</a>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./js/ui/themeThumbList/listItem.ejs
// module id = 397
// module chunks = 1